var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mod__account-process"},[_c('ProcessIndicator',{attrs:{"status":_vm.accountProcess.code}}),_vm._v(" "),_c('ProcessTips'),_vm._v(" "),_c('ProcessActions',{attrs:{"hidden-return-btn":_vm.hiddenReturnBtn,"show-problem-link":_vm.showProblemLink,"process":_vm.accountProcess},on:{"back":_vm.close}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }